import { useEffect, RefObject } from "react"

/**
 * Preloads an image fully before adding the "loaded" class.
 * This prevents progressive JPEG rendering from showing partial images.
 */
export const useImagePreload = (
  src: string,
  imgRef: RefObject<HTMLImageElement | null>,
) => {
  useEffect(() => {
    const img = new Image()
    img.src = src
    img.onload = () => {
      if (imgRef.current) {
        imgRef.current.classList.add("loaded")
      }
    }

    return () => {
      img.src = ""
    }
  }, [src, imgRef])
}

